import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { AlertStock } from "src/services/Api/Organization/types";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as PreviewArrowIcon } from "go-core/images/svg/actions/preview-arrow.svg";
import { FILTER_SEPARATOR, NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { selectOrganization } from "go-security/services/organizations/selectors";

interface DashboardProductsListBodyProps {
	stock: AlertStock;
}

export const DashboardProductsListBody = ({ stock }: DashboardProductsListBodyProps) => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const { isMobile } = useWindowSize();
	const horizontalPaddingBasedOnMobile = isMobile ? "px-1" : "";

	return (
		<div className="table-responsive">
			<table className="dashboard-products-table table">
				<thead>
					<th className={`name ${horizontalPaddingBasedOnMobile}`}>
						{t("modules.dashboard.stocks_list.field.product_name.title")}
					</th>
					<th className={`summary ${horizontalPaddingBasedOnMobile}`}>{t("lib:common.word.summary")}</th>
					<th className={`preview ${horizontalPaddingBasedOnMobile}`} />
				</thead>
				<tbody>
					{stock.products.map((product) => {
						const measureType = t(`enums.products.measure_types.${product.measure_type}`);
						const summary = `${product.state?.in_stock_amount}${measureType} / ${product.state?.commited_amount}${measureType} / ${product.state?.incoming_amount}${measureType}`;

						const filter = btoa(
							unescape(
								encodeURIComponent(
									`${NEW_WAY_TO_ENCODING_FILTER_SIGN}${FILTER_SEPARATOR}stockIds|e=${stock.stock_id}${FILTER_SEPARATOR}productIds|e=${product.id}${FILTER_SEPARATOR}available_amount|lt=0`
								)
							)
						);
						const link = organization.id !== undefined ? `/${organization.id}/states?f=${filter}` : "/";

						return (
							<tr key={product.id}>
								<td className={`${horizontalPaddingBasedOnMobile}`}>
									<Link to={link} target={"_blank"} rel={"noreferrer"}>
										{product.name}
									</Link>
								</td>
								<td className={`${horizontalPaddingBasedOnMobile}`}>{summary}</td>
								<td className={`${horizontalPaddingBasedOnMobile}`}>
									<Link to={link} target={"_blank"} rel={"noreferrer"}>
										<PreviewArrowIcon />
									</Link>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};
